module.exports = __webpack_public_path__ + "media/images/logo-color-4737025f316598ab426e463dfaa52529.svg";